import React from 'react';
import { useSelector } from 'react-redux';
import SplashBall from '../../components/Splash/splashBall';

import { getMedalPrintData } from '../../actions/event-profile-actions';
import { getIsMedalPrintDataLoading, getMedalPrintDataSelector } from '../../selectors/eventActionSelectors';
import MedalReport from './MedalReport';

import styles from './medalReportPrintPage.scss';

const MedalReportPrintPage = () => {
    const isLoadingMedalPrintData = useSelector(getIsMedalPrintDataLoading);
    const { data: medalPrintData } = useSelector(getMedalPrintDataSelector);

    if (isLoadingMedalPrintData || !medalPrintData) {
        return <SplashBall title="Printing Medals" description="Loading..." />;
    }

    return (
        <div className={styles.container}>
            <MedalReport
                eventName={medalPrintData.eventName}
                drawName={medalPrintData.drawName}
                drawDate={medalPrintData.drawDate}
                drawWinners={medalPrintData.drawWinners}
                otherDrawWinners={medalPrintData.otherDrawWinners}
                message={medalPrintData.message}
            />
        </div>
    );
};

export default {
    component: MedalReportPrintPage,
    loadData: ({ dispatch }, match) => dispatch(getMedalPrintData({ eventId: match.params.eventId, drawId: match.params.drawId })),
};

MedalReportPrintPage.propTypes = {
};

MedalReportPrintPage.defaultProps = {
};
